module.exports = {
  __depends__: [
    require(7),
    require(92)
  ]
};